import { motion } from "framer-motion";
import "./GroupCoaching.css";
import heroImg from "../assets/hero-group.jpg";
import coachTeam from "../assets/coach-photo.webp";
import actionImg from "../assets/group-action.jpg";
import trophyImg from "../assets/trophy.jpg";
import { Link } from "react-router-dom";

export default function GroupCoaching() {
  return (
    <motion.section
      className="group-page"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* === Hero Banner === */}
      <div
        className="hero-banner"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay">
          <h1>Group Badminton Coaching – Melbourne</h1>
          <p>Train Together. Improve Together. Play Fearless at SmashKaro.</p>
          {/* 🔸 Redirect to Availability Form */}
          <Link to="/availability" className="hero-btn">Enroll Now</Link>
        </div>
      </div>

      {/* === Overview Section === */}
      <div className="overview">
        <h2>Train Smarter With Your Squad</h2>
        <p>
          SmashKaro’s group sessions build skill and teamwork in a supportive, fun, and competitive environment.
          Our small group sizes ensure personalised attention while creating the perfect balance of intensity and collaboration.
        </p>
        <p>
          Every session blends technical training, conditioning, and game scenarios that make you move faster, react sharper, and
          dominate rallies. Whether you’re a junior or adult, you’ll train smarter — and have fun doing it!
        </p>
      </div>

      {/* === Pricing Section === */}
      <div className="pricing-section">
        <h2>Group Coaching Options</h2>
        <table className="pricing-table">
          <thead>
            <tr>
              <th>Session Type</th>
              <th>Players per Group</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Junior / Beginner</td>
              <td>Up to 6 Players</td>
              <td>from $35 / hour per person</td>
            </tr>
            <tr>
              <td>Intermediate / Advanced</td>
              <td>Up to 4 Players</td>
              <td>from $35 / hour per person</td>
            </tr>
          </tbody>
        </table>
        <p className="note">
          ✳️ Rackets can be provided if required.  
          ✳️ Discounts apply for regular weekly bookings.
        </p>
      </div>

      {/* === Provided / Bring Section === */}
      <div className="provided-section">
        <div>
          <h3>What’s Provided</h3>
          <ul>
            <li>Professional coaching</li>
            <li>Training shuttles</li>
            <li>All on-court equipment</li>
            <li>Game simulation drills</li>
            <li>Progress tracking</li>
          </ul>
        </div>
        <div>
          <h3>What To Bring</h3>
          <ul>
            <li>Water bottle</li>
            <li>Non-marking shoes</li>
            <li>Sportswear</li>
            <li>Racket (optional)</li>
            <li>Positive energy 💪</li>
          </ul>
        </div>
      </div>

      {/* === Photo & Coach Section === */}
      <div className="coach-section">
        <img src={coachTeam} alt="Group Coaching" className="coach-photo" />
        <div className="coach-info">
          <h2>Why Choose SmashKaro Group Coaching?</h2>
          <p>
            Our group sessions are led by certified coaches who know how to balance individual growth with team play.
            Expect clear instructions, structured routines, and plenty of rally time.
          </p>
          <ul>
            <li>Small group focus — no overcrowded courts</li>
            <li>Individual progress tracking</li>
            <li>Fun and competitive match setups</li>
            <li>Encouraging environment for all levels</li>
          </ul>
        </div>
      </div>

      {/* === Action Section === */}
      <div className="action-section">
        <img src={actionImg} alt="Group Training Action" className="action-img" />
        <div className="action-overlay">
          <h2>Teamwork Builds Champions</h2>
          <p>Learn. Challenge. Grow. Together — the SmashKaro way.</p>
        </div>
      </div>

      {/* === Footer CTA === */}
      <div className="book-section" style={{ backgroundImage: `url(${trophyImg})` }}>
        <div className="book-overlay">
          <h2>Join the SmashKaro Squad Today!</h2>
          {/* 🔸 Redirect to Availability Form */}
          <Link to="/availability" className="hero-btn">Book Now</Link>
        </div>
      </div>
    </motion.section>
  );
}
